import { c as _c } from "react/compiler-runtime";
type PaymentFormSummaryProps = {
  paymentAmount: number;
  paymentRecurring: boolean;
  paymentType: string;
};
export function PaymentFormSummary(t0) {
  const $ = _c(9);
  const {
    paymentAmount,
    paymentRecurring,
    paymentType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="block uppercase tracking-[0.02rem]">Total</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = paymentRecurring ? "Monthly" : "";
  let t3;
  if ($[1] !== paymentAmount || $[2] !== t2) {
    t3 = <p className="font-bold text-[1.375rem] uppercase">US${paymentAmount} {t2}</p>;
    $[1] = paymentAmount;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = paymentType === "paypal" ? "PayPal" : "Credit Card";
  let t5;
  if ($[4] !== t4) {
    t5 = <p className="tracking-[0.02rem]">By {t4}</p>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <div className="grid grid-cols-[250px_1fr] gap-8 border-christ-gray-400 border-b py-6 text-xs max-[1024px]:grid-cols-[140px_1fr] max-[640px]:grid-cols-1 max-[1024px]:gap-4 max-[640px]:gap-3">{t1}<div>{t3}{t5}</div></div>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}